import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'

import { TableContainer } from './index.styles'
import { PackagesListProps } from './types'

export const PackagesList = ({ packages }: PackagesListProps) => {
  const { npmAudit, npmList } = packages
  const { advisories, metadata = { vulnerabilities: {} } } = npmAudit ?? {}
  const { dependencies } = npmList ?? {}

  return (
    <>
      {dependencies && (
        <>
          <Typography variant="h6" component="div">
            Installed packages
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Package name</TableCell>
                  <TableCell>Version</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(dependencies).map(([key, value]) => (
                  <TableRow key={key}>
                    <TableCell>{key}</TableCell>
                    <TableCell>{`${value.version}${value.required ? `, ${value.required.version}` : ''}`}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      {metadata.vulnerabilities && (
        <>
          <Typography variant="h6" component="div">
            Vulnerabilities
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {Object.keys(metadata.vulnerabilities).map(key => (
                    <TableCell key={key}>{key}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.values(metadata.vulnerabilities).map(value => (
                  <TableCell key={value}>{value}</TableCell>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      {advisories && (
        <>
          <Typography variant="h6" component="div">
            Advisories
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Module name</TableCell>
                  <TableCell>Vulnerable versions</TableCell>
                  <TableCell>Patched versions</TableCell>
                  <TableCell>Severity</TableCell>
                  <TableCell>Overview</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.values(advisories).map(module => (
                  <TableRow key={module.module_name}>
                    <TableCell>{module.module_name}</TableCell>
                    <TableCell>{module.vulnerable_versions}</TableCell>
                    <TableCell>{module.patched_versions}</TableCell>
                    <TableCell>{module.severity}</TableCell>
                    <TableCell>{module.overview}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </>
  )
}
